import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FieldDef } from '../../config/modules.config';

@Component({
  selector: 'app-field-mapper',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './field-mapper.component.html',
  styleUrls: ['./field-mapper.component.scss']
})
export class FieldMapperComponent {
  @Input() fields: FieldDef[] = [];
  @Input() cols: string[] = [];
  @Input() maps: Record<string, string> = {};
  @Output() mapChange = new EventEmitter<{ fieldId: string; value: string }>();

  onChange(fieldId: string, value: string): void {
    this.mapChange.emit({ fieldId, value });
  }

  isMapped(fieldId: string): boolean {
    return !!(this.maps[fieldId]);
  }
}
